<template>
    <v-container fluid class="d-flex-column">
      <template>
  <v-row>
    <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
  <v-card
    class="mt-4 mx-auto"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
    <apexchart
      ref="barChart"
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series"></apexchart>

    </v-sheet>
    <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Εισπράξεις και χρεώσεις πελατών
      </div>
      <div class="subheading font-weight-light grey--text">
        Είσπραξη και χρέωση ανα ημέρα για το διάστημα {{date}} ~ {{date2}}.
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-clock
      </v-icon>
      <span class="text-caption grey--text font-weight-light">last registration 26 minutes ago</span>
    </v-card-text>
  </v-card>
   </v-col>
  <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
  <v-card
    class="mt-4 mx-auto"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
    <apexchart
      ref="pieChart"
      type="treemap"
      height="470"
      :options="treemapOptions"
      :series="distSeries"></apexchart>

    </v-sheet>
    <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Αγορές ανταλλακτικών
      </div>
      <div class="subheading font-weight-light grey--text">
        Σύνολο αγορών ανα προμηθευτή για το διάστημα {{date}} ~ {{date2}}.
        <p>(Σύνολική αξία ανταλλακτικών {{ tocurr(dincome) }})</p>
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-clock
      </v-icon>
      <span class="text-caption grey--text font-weight-light">last registration 26 minutes ago</span>
    </v-card-text>
  </v-card>
  </v-col>
  </v-row>
</template>
      <template>
        <v-card :loading="loading" class="mt-5">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Κινήσεις</h1>
            <v-spacer></v-spacer>
            <v-chip>Διαφορά ΦΠΑ: {{ tocurr(purchasesTax - chargesVat)}}</v-chip>
            <v-container fluid>
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>
            </v-container>
          </v-card-title>
          </v-card>
          <v-container fluid class="d-flex">
          <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Εισπράξεις</h1>
            <v-spacer/>
            <v-chip label outlined>
            {{ tocurr(sumField(this.credit, 'TotalValue')) }}
            </v-chip>
            </v-card-title>
          <invoice-table :search="search" :invoices="credit" :loading="loadingInc"></invoice-table>
          </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Χρεώσεις</h1>
            <v-spacer/>
        <v-btn-toggle
                    v-model="showServicesOnly"
                    background-color="white"
                    color="blue-grey darken-2"
                    multiple
                    mandatory
                  >
                    <v-btn 
                    value="Item"
                    text>
                      <v-icon>mdi-package-variant-closed</v-icon>
                    </v-btn>

                    <v-btn
                    value="Service"
                    text>
                      <v-icon>mdi-account-wrench</v-icon>
                    </v-btn>

                  </v-btn-toggle>
            <v-spacer/>
            <v-chip label outlined>
            <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                > {{ tocurr(chargesTotal) }}</span>
              </template>
              <span>Καθαρό: {{ tocurr(chargesNet) }}, ΦΠΑ: {{ tocurr(chargesVat) }} </span>
             </v-tooltip>
            </v-chip>
            </v-card-title>
          <invoice-table :search="search" :invoices.sync="debitFiltered" :loading="loadingInc"></invoice-table>
          </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Αγορές</h1>
            <v-spacer/>
            <v-btn @click.stop="toCsv(ddebit)">asf</v-btn>
            <v-chip label outlined>
             <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                > {{ tocurr(purchasesTotal) }}</span>
              </template>
              <span>Καθαρό: {{ tocurr(purchasesNet) }}, ΦΠΑ: {{ tocurr(purchasesTax) }} </span>
             </v-tooltip>
            </v-chip>
            </v-card-title>
          <invoice-table :search="search" :invoices="ddebit" contact="Supplier.Name" :loading="loadingDist"></invoice-table>
          </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Πληρωμές</h1>
            <v-spacer/>
            <v-chip label outlined>
            {{ tocurr(sumField(this.dcredit, 'TotalValue')) }}
            </v-chip>
            </v-card-title>
          <invoice-table :search="search" :invoices="dcredit" contact="Supplier.Name" :loading="loadingDist"></invoice-table>
          </v-card>
          </v-col>
          </v-row>
          </v-container>
      </template>
    </v-container>
</template>

<script>
import InvoiceTable from "../components/InvoiceTable.vue";
import {sumBy as _sumBy, filter as _filter, uniqBy as _uniqBy} from 'lodash';
import {reverse as _reverse, sortBy as _sortBy,} from 'lodash';
import VueApexCharts from 'vue-apexcharts'


export default {
  computed: {
     purchasesNet () {return this.sumField(this.ddebitnorm, 'NetValue')-this.sumField(this.ddebitpist, 'NetValue'); },
     purchasesTax () {return this.sumField(this.ddebitnorm, 'VatValue') -this.sumField(this.ddebitpist, 'VatValue') ; },
     purchasesTotal () {return this.sumField(this.ddebitnorm, 'TotalValue')-this.sumField(this.ddebitpist, 'TotalValue'); },
     chargesNet () {return this.sumField(this.normalInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'NetValue') - this.sumField(this.debitInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'NetValue'); },
     chargesVat () {return this.sumField(this.normalInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'VatValue') - this.sumField(this.debitInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'VatValue'); },
     chargesTotal () {return this.sumField(this.normalInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'TotalValue') - this.sumField(this.debitInvos.filter(e => this.showServicesOnly.includes(e.Kind)), 'TotalValue'); },
     debitFiltered () {
             if (this.showServicesOnly) {
            return this.debit.filter(e => this.showServicesOnly.includes(e.Kind));
        } else {
            return this.debit;
        }
        },
    //pist () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm == "Με πίστωση" && e.state == "Κανονικό") ), 'TotalValue')); },
    //metr () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm == "Μετρητοίς"&& e.state == "Κανονικό")), 'TotalValue')); },
    //total () { return this.tocurr(this.sumField(this.invoices.filter(e => e.state == "Κανονικό"), 'TotalValue')); },
  },
  components: {
    InvoiceTable,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      // chart
     series: [{
            name: 'Sales',
            data: []
          }],
          chartOptions: {
            chart: {
              height: 350,
              type: 'bar',
              stacked: false,
            },
            plotOptions: {
              bar: {
                columnWidth: '85%',
                borderRadius: 0,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: false,
              formatter: this.tocurr,
              offsetY: -20,
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              }
            },

            xaxis: {
              type: "datetime",
              categories: [],
              position: 'top',
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                  }
                }
              },
              tooltip: {
                enabled: true,
              }
            },
            legend: {
              position: "top",

            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: true,
              },
              labels: {
                show: true,
                formatter: this.tocurr,
              }

            },
            //title: {
            //  text: 'Εισπράξεις για το διάστημα',
            //  floating: true,
            //  offsetY: 330,
            //  align: 'center',
            //  style: {
            //    color: '#444'
            //  }
            //}
          },


      distSeries: [{name: "asdsa" , data : []}],
      treemapOptions: {
        chart: {
          type: "treemap",
        },

        tooltip: {
                enabled: true,
            y: {
             title: {
                 formatter: function(val) {
                    return val.length > 15 ? val.slice(0, 15) + '...' : val
                }, 
             },
            formatter:  this.tocurr
            },
        },
       dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
            },
         formatter: this.currencyFmtTree,
            offsetY: -4
          },
        plotOptions: {
          treemap: {
            enableShades: true,
            //distributed: true,
          }
        },
      },
      // data
      menu: false,
      menu2: false,
      dcredit: [],
      showServicesOnly: ['Item','Service'],
      ddebit: [],
      ddebitnorm: [],
      ddebitpist: [],
      dincome: [0, 0],
      credit: [],
      debit: [],
      normalInvos:[],
      debitInvos: [],
      income: [0, 0],
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      expanded: [],
      timdialog: false,
      diaitems: {},
      loading: true,
      loadingInc: true,
      loadingDist: true,
      balance: 0.0,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      search: "",
      customer_id: this.$route.params.id,
      invoices: [],

    };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    await this.fetchdata();
    await this.fetchdistdata();
    this.updateChart();
  },
  watch: {
    timdialog(val) {
      val || this.close();
    },
    async date() {
      if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "income",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchdata();
      await this.fetchdistdata();
      this.updateChart();
      }
    },
    async date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "income",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchdata();
      await this.fetchdistdata();
      this.updateChart();
      }
    },
  },
  methods: {
    currencyFmtTree(text, op) {
      let pcnt =  ((op.value / this.dincome)*100).toFixed(2);
      return [text, this.tocurr(op.value) +  " ("  +pcnt + "%)" ];
    },
    updateChart () {
      let labels = [];
      let values =[{ data: [], name: "credit"}, {data: [], name: "debit"}];
      for (let date of this.uniq(_sortBy(this.credit, 'Date'), 'Date')) {
        labels.push(date);
        values[0].data.push(this.sumField(_filter(this.credit, {"Date": date}), 'TotalValue'));
        values[1].data.push(this.sumField(_filter(this.debit, {"Date": date}), 'TotalValue'));
      }
      this.series = values
      this.chartOptions = { xaxis: {categories: labels}}


      // let arr = this.sumDist();
      // this.distSeries = arr.series;
      // this.pieOptions = {labels: arr.labels};
      this.distSeries = [{ data: this.sumDistTree()}];
    },
    sumDistTree() {
      let series = [];
      for (let dist of _uniqBy(this.ddebit, "Supplier.Id")) {
        let a = _sumBy(
          _filter(this.ddebit, {'Supplier': {'Id': dist.Supplier.Id}}),
          'TotalValue'
        );

        // console.log(dist.Supplier.Name, a);
        series.push({x: dist.Supplier.Name, y: a});
      }
      return _reverse(_sortBy(series, 'y'));
    },
    sumDist() {
      let val = [];
      let labels = [];
      for (let dist of this.uniq(this.ddebit, "Customer")) {
        let a = this.sumField(
          _filter(this.ddebit, {"Customer": dist}),
          "TotalValue"
        );
        val.push(a);
        labels.push(dist);
      }
      return {"series": val, "labels": labels};
    },
    functionEvents (date) {
      return this.credit.some(e => e.Date == date);
    },
    close() {
      this.timdialog = false;
    },
    async fetchdata() {
      try {
        this.loading = true;
        this.loadingInc = true;
        let response = await this.$api.get("/customers/transactions", {
          params: {
            start_date: this.date,
            end_date: this.date2,
          },
        });
        //console.log(response);

        this.debit = response.data[0];
        this.normalInvos = this.debit.filter(d => {return !(d.SeriesCode == 6001 || d.SeriesCode == 4001 || d.CancelledBy != null) ;})
        this.debitInvos = this.debit.filter(d => {return d.SeriesCode == 4001;})
        this.credit = response.data[1];

       // response = await this.$api.get("/customers/date-balance", {
       //   params: {
       //     start_date: this.date,
       //     end_date: this.date2,
       //   },
       // });
       // this.income = response.data
        this.loading = false;
        this.loadingInc = false;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchdistdata() {
      try {
        this.loading = true;
        this.loadingDist = true;
        let response = await this.$api.get("/suppliers/transactions", {
          params: {
            start_date: this.date,
            end_date: this.date2,
          },
        });
        // console.log(response);

        this.ddebit = response.data[0];
        this.ddebitnorm = this.ddebit.filter(e=> {return e.InvoiceType=="1.1" || e.InvoiceType=="2.1"})
        this.ddebitpist = this.ddebit.filter(e=> {return e.InvoiceType=="5.1" || e.InvoiceType=="5.2"})
        this.dcredit = response.data[1];
        this.dincome =  this.sumField(response.data[0], 'TotalValue');
       // response = await this.$api.get("/distributors/date-balance", {
       //   params: {
       //     start_date: this.date,
       //     end_date: this.date2,
       //   },
       // });
       // this.dincome = response.data
        this.loading = false;
        this.loadingDist = false;
      } catch (error) {
        console.error(error);
      }
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    
    toCsv(items) {  
    // create the topline (column headers)
    let topLine = Object.keys(items[0]).join(";");

    // create lines with values
    const lines = items.reduce( (acc, val) => 
      acc.concat( Object.values(val).join(`;`) ), [] );

    // concat both strings
    const csv = topLine.concat(`\n${lines.join(`\n`)}`);
    console.log(csv);
    },
    
    
    uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },
};
</script>
